import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { RefundsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createRefund = (data, callbackFunction = undefined): any => action(types.CREATE_REFUND_REQUESTED, {
  data,
  callbackFunction,
});

export const updateRefund = (data): any => action(types.UPDATE_REFUND_REQUESTED, data);

export const deleteRefund = (refundId): any => action(types.UPDATE_REFUND_REQUESTED, refundId);

export const getRefund = (refundId): any => action(types.GET_REFUND_REQUESTED, refundId);

export const getAllRefunds = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_REFUNDS_REQUESTED, {
  pagination,
  compile,
});

export const selectRefund = (refundId): any => action(types.SELECT_REFUND_REQUESTED, {
  currentRefundId: refundId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createRefundPending: (payload): any => action(types.CREATE_REFUND_PENDING, payload),
  createRefundSuccess: (response): any => {
    const currentRefund = response.entities.refunds[response.result];
    // history.push(`/payment/${currentRefund.paymentCollection.id}/review`);
    return action(types.CREATE_REFUND_SUCCESS, {
      refundsById: response.entities.refunds,
      currentRefundId: response.result,
    });
  },
  updateRefundPending: (payload): any => action(types.UPDATE_REFUND_PENDING, payload),
  updateRefundSuccess: (response): any => action(types.UPDATE_REFUND_SUCCESS, {
    refundsById: response.entities.refunds,
    currentRefundId: response.result,
  }),
  updateRefundFailed: (error): any => action(types.UPDATE_REFUND_FAIL, {
    backendErrors: error,
  }),
  deleteRefundPending: (): any => action(types.UPDATE_REFUND_PENDING, {}),
  deleteRefundSuccess: (response, userId): any => {
    localStorage.set(userId, { currentRefundId: null });
    history.push('/refunds');

    return action(types.DELETE_REFUND_SUCCESS, {
      currentRefundId: response,
    });
  },
  getRefundPending: (): any => action(types.GET_REFUND_PENDING, {}),
  getRefundSuccess: (response): any => action(types.GET_REFUND_SUCCESS, {
    refundsById: response.entities.refunds,
    currentRefundId: response.result,
  }),
  getRefundFailed: (error): any => action(types.GET_REFUND_FAIL, {
    backendErrors: error,
  }),
  deleteRefundFailed: (error): any => action(types.UPDATE_REFUND_FAIL, {
    backendErrors: error,
  }),
  getAllRefundsPending: (pagination): any => action(types.GET_ALL_REFUNDS_PENDING, { pagination }),
  getAllRefundsSuccess: (response, meta): any => action(types.GET_ALL_REFUNDS_SUCCESS, {
    refundsById: response.entities.refunds,
    refundIds: response.result,
    meta,
  }),
  getAllRefundsFailed: (error): any => action(types.GET_ALL_REFUNDS_FAIL, {
    backendErrors: error,
  }),
  createRefundFailed: (error): any => action(types.CREATE_REFUND_FAIL, {
    backendErrors: error,
  }),
};

export default null;
